import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  logo: {
    color: '#7df3e1',
    fontSize: 18,
    fontWeight: 700,
  },
});

export const LogoIcon = () => {
  const classes = useStyles();
  return <div className={classes.logo}>IT</div>;
};

